/**
 * Collects browser context and approximate location (country/region via IP lookup)
 * for feedback submissions. Geo uses a public HTTPS API; failures are silent.
 */

function browserFromUa(ua) {
  if (!ua) return "";
  if (/Firefox\//.test(ua)) return "Firefox";
  if (/\bEdg\b|Edg\//.test(ua)) return "Microsoft Edge";
  if (/CriOS\//.test(ua)) return "Chrome";
  if (/OPR\/|Opera/.test(ua)) return "Opera";
  if (/Chrome\//.test(ua) || /Chromium/.test(ua)) return "Chrome";
  if (/Safari\//.test(ua)) return "Safari";
  if (/SamsungBrowser/.test(ua)) return "Samsung Internet";
  return "Unknown browser";
}

function osFromUa(ua) {
  if (!ua) return "";
  if (/Windows NT 10\.0|Windows NT 11/.test(ua)) return "Windows 10/11";
  if (/Windows/.test(ua)) return "Windows";
  if (/Mac OS X/.test(ua)) return "macOS";
  if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
  if (/Android/.test(ua)) return "Android";
  if (/Linux/.test(ua)) return "Linux";
  return "";
}

export function buildBrowserLabel(userAgent) {
  const ua = userAgent || "";
  const b = browserFromUa(ua);
  const os = osFromUa(ua);
  if (b && os) return `${b} · ${os}`;
  return b || os || ua.slice(0, 200);
}

async function fetchGeoFromIpLookup() {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), 8000);
  try {
    const res = await fetch("https://ipwho.is/", {
      signal: ctrl.signal,
      credentials: "omit",
    });
    if (!res.ok) return null;
    const j = await res.json();
    if (!j || j.success === false) return null;
    return {
      country: typeof j.country === "string" ? j.country : "",
      region: typeof j.region === "string" ? j.region : "",
      city: typeof j.city === "string" ? j.city : "",
      countryCode: typeof j.country_code === "string" ? j.country_code : "",
    };
  } catch {
    return null;
  } finally {
    clearTimeout(t);
  }
}

/**
 * @returns {Promise<{ userAgent: string, browserLabel: string, locale: string, geo: object | null }>}
 */
export async function getFeedbackClientContext() {
  const userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const browserLabel = buildBrowserLabel(userAgent);
  const locale =
    typeof navigator !== "undefined" && navigator.language
      ? navigator.language
      : "";

  const geo = await fetchGeoFromIpLookup();

  return {
    userAgent,
    browserLabel,
    locale,
    geo,
  };
}
